(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VueAudioRecorder", [], factory);
	else if(typeof exports === 'object')
		exports["VueAudioRecorder"] = factory();
	else
		root["VueAudioRecorder"] = factory();
})(window, function() {
return 